var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMetamask16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.75 169.036 1.752.465v-.608l.143-.143h1v1.216h-1.071l-1.323-.572z",
    fill: "#cdbdb2",
    transform: "translate(-55.688 -155.848)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 .93 1.716-.465v.608l.143.143h1v-1.216h-1.071l-1.323.572z",
    fill: "#cdbdb2",
    transform: "matrix(-1 0 0 -1 10.784 14.118)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m75.375 27 .858 2 .393 5.829h1.395l.429-5.829.787-2z",
    fill: "#f89c35",
    transform: "translate(-69.383 -23.109)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m1.564 80.386-1 2.9 2.5-.143h1.611v-1.255l-.075-2.575-.358.286z",
    fill: "#f89d35",
    transform: "translate(.673 -72.097)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m46.125 101.25 2.932.072-.322 1.5-1.395-.358z",
    fill: "#d87c30",
    transform: "translate(-41.992 -92.639)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m46.125 101.813 1.216 1.144v1.143z",
    fill: "#ea8d3a",
    transform: "translate(-41.992 -93.166)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m65.25 120.375 1.43.358.465 1.538-.322.179-1.573-.93z",
    fill: "#f89d35",
    transform: "translate(-59.902 -110.548)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m61.036 138.375-.286 2.217 1.9-1.323z",
    fill: "#eb8f35",
    transform: "translate(-55.688 -127.404)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m86.983 102.375.179 3.04-.536-1.556z",
    fill: "#ea8e3a",
    transform: "translate(-79.918 -93.692)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m39.375 138.411 1.645-.036-.286 2.217z",
    fill: "#d87c30",
    transform: "translate(-35.672 -127.404)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m1.35 142.085 3.04-.966-1.36-2.181-2.467.179z",
    fill: "#eb8f35",
    transform: "translate(.673 -127.931)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m48.843 58.5-1.538 1.287-1.18 1.43 2.932.107z",
    fill: "#e8821e",
    transform: "translate(-41.992 -52.607)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m60.75 153.761 1.9-1.323-.143 1.144v.644l-1.287-.25z",
    fill: "#dfcec3",
    transform: "translate(-55.688 -140.573)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m0 .465 1.86 1.323-.144-1.144v-.644l-1.287.25z",
    fill: "#dfcec3",
    transform: "matrix(-1 0 0 -1 10.784 13.653)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m.393.823-.393-.823 1.395.358z",
    fill: "#393939",
    transform: "matrix(-1 0 0 -1 6.671 10.149)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m12.375.563 4.863 3.683-.822-2z",
    fill: "#e88f35",
    transform: "translate(-10.388 1.647)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m2.894.563-.644 1.966.358 2.146-.25.143.358.322-.286.25.393.358-.25.215.572.715 2.682-.822a23.486 23.486 0 0 0 1.93-1.61q-.036-.036-4.863-3.683z",
    fill: "#8e5a30",
    transform: "translate(-.907 1.648)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 -1 14.61 14.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 2.9-1-2.9 2.5.143h1.612v1.252l-.071 2.574-.358-.286z",
    fill: "#f89d35",
    transform: "translate(0 2.968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1.573 2.932-.073-.322-1.5-1.394.358z",
    fill: "#d87c30",
    transform: "translate(2.897 3.969)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.289 1.216-1.145v-1.144z",
    fill: "#ea8d3a",
    transform: "translate(2.897 3.218)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.074 1.43-.358.47-1.537-.327-.179-1.573.93z",
    fill: "#f89d35",
    transform: "translate(4.112 2.253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.286 2.217-.286-2.217 1.86 1.287z",
    fill: "#eb8f35",
    transform: "translate(3.826 .966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.358 3.04.178-3.04-.536 1.556z",
    fill: "#ea8e3a",
    transform: "translate(5.471 2.432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 2.181 1.645.036-.286-2.217z",
    fill: "#d87c30",
    transform: "translate(2.467 .966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.787 0 3.04.966-1.36 2.181-2.467-.179z",
    fill: "#eb8f35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.718 2.825-1.538-1.287-1.18-1.431 2.932-.107z",
    fill: "#e8821e",
    transform: "translate(2.897 5.435)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.393 0-.393.823 1.395-.358z",
    fill: "#393939",
    transform: "matrix(-1 0 0 -1 5.435 4.828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.683 4.863-3.683-.822 2z",
    fill: "#e88f35",
    transform: "translate(.751 8.261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.644 6.115-.644-1.967.358-2.148-.251-.14.358-.322-.286-.25.393-.358-.25-.215.572-.715 2.682.822a23.486 23.486 0 0 1 1.931 1.61q-.036.035-4.863 3.683z",
    fill: "#8e5a30",
    transform: "translate(.107 5.829)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMetamask16);
export default __webpack_public_path__ + "static/media/ic_metamask_16.aa3dce327008d9c000cfad2c3287ff03.svg";
export { ForwardRef as ReactComponent };